import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getRackModel = (storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/rack-config/' + storeId,
    headers: getHeaders(),
  });
};
 